/**
 * 写真情報をAPIパラメータに変換する関数
 * @param {Object} selectedImage 選択中の写真情報
 * @returns {Object} 報告書フレーム操作APIのパラメータ
 */
export default function convertTimelineToApiParams(selectedImage) {
  if (selectedImage === 'noImage') {
    return {};
  }

  const tags = selectedImage.tags.reduce((acc, tagItem) => {
    // lastTagIdを初期化し、存在するタグの名前を格納するオブジェクトを初期化
    let lastTagId = null;
    const tagNames = {};

    Object.keys(tagItem).forEach(tagKey => {
      const tag = tagItem[tagKey];
      if (tag) {
        lastTagId = tag.id; // 最後に見つかったタグのIDをlastTagIdとする
        tagNames[tagKey] = tag.name; // タグの名前を追加
      }
    });

    // タグオブジェクトにプロパティが1つでも存在する場合、配列に追加
    if (Object.keys(tagNames).length > 0) {
      acc.push({ ...tagNames, lastTagId });
    }
    return acc;
  }, []);

  const apiParams = { workRecordId: selectedImage.id };

  // tagsが空でない場合のみ、apiParamsに追加
  if (tags.length > 0) {
    apiParams.tags = tags;
  }

  // freeTagが存在する場合、apiParamsに追加
  if (selectedImage.freeTag && selectedImage.freeTag.trim() !== '') {
    apiParams.freeTag = selectedImage.freeTag;
  }

  return apiParams;
}
